var module = angular.module('octopusApp.configuration');

module.controller('FeaturesEditController', function($scope, $q, $location, busy, octopusRepository, unsavedChanges, $window) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.config = {
        IsMultiTenancyEnabled: false,
        IsDockerEnabled: false,
        IsCommunityActionTemplatesEnabled: true
    };

    $scope.lastSync = 'Not run';
    $scope.lastSyncTextClass = 'library-step-sync-default';
    $scope.lastSyncFailed = false;
    $scope.lastSyncTaskUrl = '';

    function init() {
        isLoading.promise(octopusRepository.FeaturesConfiguration.get().then(function (config) {
            $scope.config = config;
            $scope.IsCommunityActionTemplatesEnabledOnLoad = config.IsCommunityActionTemplatesEnabled;

            var queries = [];

            if ($scope.config.IsMultiTenancyEnabled) {
                queries.push(octopusRepository.Tenants.all().then(function(tenants) {
                    $scope.hasTenants = _.size(tenants) > 0;
                }));
            }

            if ($scope.config.IsCommunityActionTemplatesEnabled) {
                queries.push(octopusRepository.Tasks.filter({name: 'SyncCommunityActionTemplates', take: 1}).then(function(tasks) {
                    if (_.size(tasks.Items) > 0) {
                        var tasksByCompleted = _.sortBy(tasks.Items, 'CompletedTime');
                        var task = _.last(tasksByCompleted);
                        $scope.lastSync = task.CompletedTime;
                        $scope.lastSyncTextClass = task.FinishedSuccessfully ? 'library-step-sync-success' : 'library-step-sync-failed';
                        $scope.lastSyncFailed = !task.FinishedSuccessfully;
                        $scope.lastSyncTaskUrl = '#/tasks/' + task.Id;
                    }
                }));
            }

            if (queries.length > 0) {
                return $q.all(queries);
            }
        }));
    }

    $scope.save = function() {
        isSaving.promise(octopusRepository.FeaturesConfiguration.modify($scope.config).then(function(config) {
            $scope.config = config;
            unsavedChanges.saved();
            $window.location.reload();
        }));
    };

    $scope.synchronizeLibrarySteps = function() {

        var task = {
            Name: 'SyncCommunityActionTemplates',
            Description: 'Synchronize Community Step Templates'
        };
        $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
            $location.path("/tasks/" + result.Id);
        }));

    };

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/features/controllers/features_edit_controller.js
// module id = 391
// module chunks = 1